
// Поменять контрактные данные под себя

const Contacts = () => {
    return ( 
        <main className="section">
        <div className="container">
                <h1 className="title-1">Contacts</h1>

                <ul className="content-list">
                    <li className="content-list__item">
                        <h2 className="title-2">Location</h2>
                        <p>Voronezh, Russia</p>
                    </li>
                    <li className="content-list__item">
                        <h2 className="title-2">Telegram / WhatsApp</h2>
                        <p><a href="tel:+79051234567">+7 (919) 245-01-94</a></p>
                    </li>
                    <li className="content-list__item">
                        <h2 className="title-2">Email</h2>
                        <p><a href="mailto:OnyxLotus@yandex.ru">OnyxLotus@yandex.ru</a></p>
                    </li>
                </ul>

        </div>
    </main>
     );
}
 
export default Contacts;